<template>
  <div data-testid="usernickname-reviews">
    {{ userNickname }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  userNickname: string;
}>();
</script>
